module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("67kTb"))).then(() => parcelRequire('3v14P'));